<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
          <div class="row d-flex justify-content-end mr-0 mb-3">
              <div class="col-auto pr-0">
                <CButton color="success" @click="createUser()">
                  <CIcon :content="$options.addIcon" /> {{ $t('button.create') }} {{ $tc('users.label', 1) }}
                </CButton>
              </div>
          </div>
          <CDataTable
            :items="filteredItems"
            :fields="fields"
            :items-per-page="perPage"
            :itemsPerPageSelect="itemsPerPage"
            :tableFilter="tableFilter"
            :table-filter-value.sync="search"
            :loading="loading"
            addTableClasses="d-print-table table-dropdown-fix"
            hover
            sorter
            pagination
          >
          <template #status="{item}">
            <td>
              <CBadge :color="item.status_class">{{ item.status ? $t('fields.active') : $t('fields.inactive') }}</CBadge>
            </td>
          </template>
          <template #options="{item}">
            <td>
              <div class="dropdown">
                <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                  {{ $t('button.options') }}
                </button>
                <div class="dropdown-menu">
                  <button class="dropdown-item" type="button" @click="showUser(item.id)">{{ $t('button.details') }}</button>
                  <button class="dropdown-item" type="button" @click="editUser(item.id)">{{ $t('button.edit') }}</button>
                  <button class="dropdown-item" type="button" @click="deleteUser(item.id)">{{ $t('button.delete') }}</button>
                </div>
              </div>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import listMixin from '../../mixins/list';
import i18n from "../../i18n";
import localeMixin from '../../mixins/locale';
import { cilPlus } from '@coreui/icons';

export default {
  name: 'Users',
  mixins: [listMixin, localeMixin],
  addIcon: cilPlus,
  data() {
    return {
      items: [],
      fields: [
        'id', 
        'username', 
        'name',
        'registered', 
        'role', 
        'status', 
      {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
      }],
      tableFilter: {
        label: "Buscar:",
        placeholder: i18n.t('users.search_placeholder'),
        lazy: false,
        external: true
      },
    }
  },
  tableFilter: {
    label: i18n.t('search'),
    placeholder: i18n.t('users.search_placeholder'),
    lazy: false,
    external: true
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => {
        return i.username.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  methods: {
    createUser () {
      this.$router.push({ name: 'CreateUser'});
    },
    showUser(id) {
      this.$router.push({ name: 'User', params: {id} });
    },
    editUser(id) {
      this.$router.push({ name: 'EditUser', params: {id} });
    },
    deleteUser(id) {
      this.$swal({
        title: i18n.t('users.modal.delete_label'),
        html: i18n.t('users.modal.delete_body'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('button.accept')
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/users/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
            this.$swal(
              i18n.t('users.modal.updated_label'),
              i18n.t('users.modal.updated_body'),
              'success'
              );
              this.getUsers();
          });
        }
      });
    },
    getUsers() {
      axios.get('/api/users?token=' + localStorage.getItem("api_token"))
      .then(response => {
        this.items = response.data;
        this.items.forEach(elem => {
          elem.status_class = elem.status ? "success" : "secondary";
        });
      }).catch(error => {
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    }
  }
}
</script>
